module.exports = __webpack_public_path__ + "static/img/slide_3.8695c87.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/consulting/slider/slide_3.png
// module id = nalt
// module chunks = 0